<template>
    <div
        v-if="views && views.points.length > 1"
        :class="['visual-rotate', {'is-open': isOpen}]"
    >
        <button class="button-circle_theme_white visual-rotate__open-button"
                @click="changeRotateByButton">
            Сменить ракурс
            <iconRotate className="visual-rotate__svg-rotate"/>
        </button>
        <div class="visual-rotate__container">
            <div v-if="views.planHouse" class="visual-rotate__house-plan">
                <img :src=views.planHouse alt="План комплекса">
            </div>
            <div class="visual-rotate__wrapper">
                <img class="visual-rotate__plan" :src=views.plan alt="Мини план">

                <template v-for="point in views.points">
                    <div
                        :class="['visual-rotate__point', {'is-active': point.id == rotate}]"
                        :style="{top: `${point.top}px`, left: `${point.left}px`, transform: `rotate(${point.deg}deg)`}"
                        :key="point.id"
                        @click="changeRotateByClick(point.id)"
                    >
                        <iconGradient className="visual-rotate__svg-gradient"/>
                        <div class="visual-rotate__circle"></div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<style lang='scss'>
    @import "./Rotate.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import iconClose from '../Icons/icon-close.vue';
import iconGradient from '../Icons/icon-rotate-gradient.vue';
import iconRotate from '../Icons/icon-rotate.vue';

export default {
    data: () => {
        return {
            isOpen: false
        };
    },

    components: {
        iconGradient,
        iconRotate,
        iconClose
    },

    computed: {
        ...mapGetters({
            views : 'GET_VIEWS',
            rotate: 'GET_ROTATE'
        })
    },

    methods: {
        ...mapActions(['changeRotate']),

        changeRotateByClick(id) {
            this.changeRotate(id);
            this.isOpen = false;
            sessionStorage.setItem('rotate', `${id}`);
        },

        changeRotateByButton() {
            const rotateId = sessionStorage.getItem('rotate');
            let newRotateId = null;

            if (parseInt(rotateId, 10) < this.views.points.length) {
                newRotateId = (parseInt(rotateId, 10) + 1).toString();
            } else {
                newRotateId = 1;
            }

            this.changeRotateByClick(newRotateId);
        }
    },

    created() {
        const rotateId = sessionStorage.getItem('rotate');

        if (!rotateId) {
            return;
        }

        this.changeRotate(rotateId);
    }
};
</script>

